module.exports = __webpack_public_path__ + "static/img/baozhiIcon.641cb37a.png";